<div class="content-wrapper">
  <div class="row">
    <div class="col-lg-12 grid-margin stretch-card">
      <div class="card">

        <div class="card-body">
          <h4 class="card-title">Employees</h4>
          <p-contextMenu #cm [model]="items"></p-contextMenu>

          <div class="card">

            <p>Employee Count: {{size}}</p>
            <p-table #dt2 [value]="Employees" dataKey="id" [rows]="10" [showCurrentPageReport]="true"
              [rowsPerPageOptions]="[10,25,50]" [loading]="loading" [paginator]="true"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
              [(contextMenuSelection)]="UpdateEmployee" [contextMenu]="cm"
              [globalFilterFields]="['firstName','lastName','contractorName','locationName','departmentName','status']">
              <ng-template pTemplate="caption">

                <div class="form-group">
                  <div class="input-group">
                    <input type="text" class="form-control" placeholder="search" aria-label="Recipient's username"
                      (input)="dt2.filterGlobal($event.target.value, 'contains')">
                    <div class="input-group-append">
                      <button class="btn btn-sm btn-primary" type="button">Search</button>
                    </div>
                  </div>
                </div>
                <div class="input-group-append">
                  <button class="btn btn-sm btn-primary" type="button" (click)="downloadExcel()">Download</button>
                </div>
              </ng-template>

              <ng-template pTemplate="header">

                <tr>
                  <th>Reference</th>
                  <th>Name</th>
                  <th>Department</th>
                  <th>Position</th>
                  <th>Work Location</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>

                <tr>
                  <th></th>

                  <th></th>

                  <th></th>

                  <th></th>

                  <th></th>

                  <th></th>
                  <th></th>
                </tr>

              </ng-template>

              <ng-template pTemplate="body" let-data>
                <tr>

                  <td>
                    {{data.reference}}
                  </td>

                  <td>
                    <span class="image-text">{{data.firstName}} {{data.lastName}}</span>
                  </td>

                  <td>
                    <span class="image-text"> {{data.departmentName}}</span>
                  </td>

                  <td>
                    {{data.position}}
                  </td>

                  <td>
                    {{data.workLocation}}
                  </td>

                  <td>

                    <button [ngClass]="getStatusColor(data.isActive)"> {{data.isActive ? 'Active' : 'Inactive'  }}</button>

                  </td>
                  <td>

                    <div class="dropdown">
                      <button class="btn btn-primary dropdown-toggle" type="button" id="dropdownMenuIconButton6"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">

                      </button>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuIconButton6">

                        <a class="dropdown-item" (click)="openSideView(data)">View</a>
                        <div class="dropdown-divider"></div>

                        <a class="dropdown-item" *ngIf="canTerminateEmployees && data.isActive" nz-popconfirm
                          nzPopconfirmTitle="Are you sure?" nzOkText="Yes" nzCancelText="Cancel"
                          (nzOnConfirm)="openOffboard(data)" (nzOnCancel)="cancel()">Off-board Employee</a>
                        <!-- <a class="dropdown-item" *ngIf="canTerminateEmployees && data.isActive" nz-popconfirm
                          nzPopconfirmTitle="Are you sure?" nzOkText="Yes" nzCancelText="Cancel"
                          (nzOnConfirm)="openTerminate(data)" (nzOnCancel)="cancel()">Exit Before Biometric/End Date</a> -->


                      </div>
                    </div>

                  </td>


                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="5">No employee found.</td>
                </tr>
              </ng-template>

            </p-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--
<nz-dropdown-menu #menu="nzDropdownMenu">
  <ul nz-menu>
    <li nz-menu-item (click)="openSideView()">View</li>
    <li nz-menu-item *ngIf="biometricOption" (click)="openBiometricCapture()">Capture Biometric Info</li>
    <li nz-menu-item *ngIf="safetyOption" (click)="openSafetyCapture()">Capture Safety Info</li>
    <li nz-menu-item  *ngIf="canTerminateEmployees"     (click)="openTerminate()">Exit Before Biometric End Date</li>


  </ul>
</nz-dropdown-menu>
-->
<!-- Drawer -->
<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="720"
  [nzVisible]="ViewEmployeeVisible" nzTitle="Create" [nzFooter]="footerTpl" (nzOnClose)="close()">

  <!-- Side swipe content -->
  <div class="row">
    <div class="col-lg-12 grid-margin stretch-card">
      <div class="card">
        <h5 class="card-title">Employee Details</h5>
        <div class="card-body">
          <div class="row">

            <div class="col">
              <label><b>Name</b></label>
              <p>{{ UpdateEmployee?.firstName }} {{ UpdateEmployee?.lastName }}</p>
            </div>

            <div class="col">
              <label><b>Email</b></label>
              <p>{{ UpdateEmployee?.email }}</p>
            </div>
          </div>

          <div class="row">

            <div class="col">
              <label><b>Phone number</b></label>
              <p>{{ UpdateEmployee?.phoneNumber }}</p>
            </div>

            <div class="col">
              <label><b>Gender</b></label>
              <p>{{ UpdateEmployee?.gender }}</p>
            </div>

          </div>

          <div class="row">

            <div class="col">
              <label><b>Age</b></label>
              <p>{{ UpdateEmployee?.age }}</p>
            </div>

            <div class="col">
              <label><b>Address</b></label>
              <p>{{ UpdateEmployee?.address }}</p>
            </div>

          </div>

          <div class="row">

            <div class="col">
              <label><b>Qualification</b></label>
              <p>{{ UpdateEmployee?.qualification }}</p>
            </div>

            <div class="col">
              <label><b>Position</b></label>
              <p>{{ UpdateEmployee?.position }}</p>
            </div>

          </div>

          <div class="row">

            <div class="col">
              <label><b>Previous Employer</b></label>
              <p>{{ UpdateEmployee?.lastPlaceOfWork }}</p>
            </div>

            <div class="col">
              <label><b>Next of Kin</b></label>
              <p>{{ UpdateEmployee?.nextOfKin }}</p>
            </div>

          </div>

          <div class="row">

            <div class="col">
              <label><b>Next of Kin's Phone</b></label>
              <p>{{ UpdateEmployee?.nextOfKinPhone }}</p>
            </div>

            <div class="col">
              <label><b>Next of Kin's Address</b></label>
              <p>{{ UpdateEmployee?.nextOfKinAddress }}</p>
            </div>

          </div>

          <div class="row">

            <div class="col">
              <label><b>Start Date</b></label>
              <p>{{ UpdateEmployee?.startDate | date: 'dd MMMM yyy'}}</p>
            </div>

            <div class="col">
              <label><b>End Date</b></label>
              <p>{{ UpdateEmployee?.endDate | date: 'dd MMMM yyy'}}</p>
            </div>

          </div>

          <div class="row">

            <div class="col">
              <label><b>Biometric Start Date</b></label>
              <p>{{ UpdateEmployee?.biometricStartDate | date: 'dd MMMM yyy' }}</p>
            </div>

            <div class="col">
              <label><b>Biometric End Date</b></label>
              <p>{{ UpdateEmployee?.biometricEndDate | date: 'dd MMMM yyy' }}</p>
            </div>

          </div>

          <div class="row">

            <div class="col">
              <label><b>Termination Date</b></label>
              <p>{{ UpdateEmployee?.terminationDate | date: 'dd MMMM yyy' }}</p>
            </div>

            <div class="col">
              <label><b>Employee Id</b></label>
              <p>{{ UpdateEmployee?.nonEmployeeID}}</p>
            </div>



          </div>


        </div>

        <hr>

        <!-- Non Editable View -->
        <div class="card-body">

          <div class="row">

            <div class="col">
              <label><b>Request Reference</b></label>
              <p>{{ UpdateEmployee?.contractReference }}</p>
            </div>

            <div class="col">
              <label><b>Function</b></label>
              <p>{{ UpdateEmployee?.departmentName }}</p>
            </div>
          </div>

          <div class="row">

            <div class="col">
              <label><b>Request Location</b></label>
              <p>{{ UpdateEmployee?.currentLocationName }}</p>
            </div>

            <div class="col">
              <label><b>Current Location</b></label>
              <p>{{ UpdateEmployee?.workLocation }}</p>
            </div>
          </div>

          <div class="row">

            <div class="col">
              <label><b>Position</b></label>
              <p>{{ UpdateEmployee?.position }}</p>
            </div>

            <div class="col">
              <label><b>Cost Center</b></label>
              <p>{{ UpdateEmployee?.costCenterName }}</p>
            </div>
          </div>

          <div class="row">

            <div class="col">
              <label><b>Start Date</b></label>
              <p>{{ UpdateEmployee?.startDate | date: 'dd MMMM yyyy' }}</p>
            </div>

            <div class="col">
              <label><b>Expected End Date</b></label>
              <p>{{ UpdateEmployee?.endDate | date: 'dd MMMM yyyy' }}</p>
            </div>

          </div>

          <div class="row">

            <div class="col">
              <label><b> Class</b></label>
              <p>{{ UpdateEmployee?.employeeClass }}</p>
            </div>

            <div class="col">
              <label><b>Role Type</b></label>
              <p>{{ UpdateEmployee?.roleType }}</p>
            </div>

          </div>

          <div class="row">
            <div class="col" *ngIf="!edit">
              <label><b>Safety Induction</b></label>
              <p *ngIf="safetyStatus">Done</p>
              <p *ngIf="!safetyStatus">Pending</p>
            </div>

            <div class="col" *ngIf="safetyOption && edit">
              <div class="form-group">
                <label><b>Safety Induction</b></label>
                <select class="form-control" required [(ngModel)]="safetyStatus" name="safetyStatus">
                  <option [ngValue]="false">Pending</option>
                  <option [ngValue]="true">Done </option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col" *ngIf="!edit">
              <label><b>Biometric Capture</b></label>
              <p *ngIf="biometricStatus">Done</p>
              <p *ngIf="!biometricStatus">Pending</p>
            </div>

            <div class="col" *ngIf="biometricOption && edit">
              <div class="form-group">
                <label><b>Biometric Capture</b></label>
                <select class="form-control" required [(ngModel)]="biometricStatus" name="biometricStatus">
                  <option [ngValue]="false">Pending</option>
                  <option [ngValue]="true">Captured </option>
                </select>
              </div>
            </div>

            <div class="col" *ngIf="biometricOption && edit">
              <div class="form-group">
                <label><b>Capture Date</b></label>
                <nz-date-picker></nz-date-picker>
              </div>
            </div>

            <div class="col" *ngIf="biometricOption && edit">
              <!-- Biometric Officer  -->
              <div class="form-group">
                <label for="bioOfficerName">Biometric Officer Name</label>
                <input type="text" class="form-control" id="bioOfficerName" placeholder="Name" name="bioOfficerName"
                  [(ngModel)]="bioOfficerName" required>
              </div>
            </div>
            <div class="col" class="formControl" *ngIf="biometricOption && edit"></div>
          </div>

          <div class="row">

            <!-- Biometric start Date  -->
            <div class="col" *ngIf="biometricOption && edit">
              <div class="form-group">
                <label for="exampleInputCity1">Biometric Start Date</label>
                <input type="date" class="form-control" id="biometricstartdate" placeholder="" name="biometricstartdate"
                  [(ngModel)]="biometricstartdate" required>
              </div>
            </div>

            <!-- Biometric End Date Duration  -->
            <div class="col" *ngIf="biometricOption && edit">
              <div class="form-group">
                <label for="exampleInputCity1">Biometric End Date</label>
                <input type="date" class="form-control" id="biometricenddate" placeholder="" name="biometricenddate"
                  [(ngModel)]="biometricenddate" required>
              </div>
            </div>

          </div>



          <div class="table-responsive" *ngIf="CanviewDocuments">
            <h5 class="card-title">Documents</h5>
            <table class="table table--striped table-hover">
              <thead>
                <tr>

                  <th>
                    Document Name
                  </th>
                  <th>
                    Document Description
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let document of Documents" class="clickable">

                  <td>{{document.documentName}}</td>
                  <td>{{document.documentDescription}}</td>

                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- Non Editable -->
    </div>
  </div>

  <!-- Side swipe content -->

  <ng-template #footerTpl>
    <div style="float: right">
      <button class="btn btn-warning" style="margin-right: 8px;" (click)="updateBiometrics()"
        *ngIf="biometricOption && edit">Update Biometric Status</button>

      <button class="btn btn-warning" style="margin-right: 8px;" (click)="updateSafety()"
        *ngIf="safetyOption && edit">Update
        Safety Status</button>

      <button class="btn btn-primary" style="margin-right: 8px;" (click)="beginEdit()"
        *ngIf="(updateButtonVisible && biometricOption && !biometricStatus) || (updateButtonVisible && safetyOption && !safetyStatus)">
        Update</button>

      <button class="btn btn-warning" style="margin-right: 8px;" (click)="openDocuments()"
        *ngIf="CanviewDocuments ||  CanAddDocuments">
        Documents
      </button>

      <button class="btn btn-primary" style="margin-right: 8px;" (click)="openChangeLocationModal()">
        Change Location</button>
      <button class="btn btn-primary" style="margin-right: 8px;" (click)="openChangeContractorModal()">
        Change Contractor</button>

      <button class="btn btn-light" style="margin-right: 8px;" style="margin-right: 8px;"
        (click)="close()">Cancel</button>
    </div>
  </ng-template>

</nz-drawer>
<!-- Drawer -->


<!-- Update Biometric  Modal  -->
<nz-modal [(nzVisible)]="isBiometricModalVisible" nzTitle={{biometricUpdateTitle}} (nzOnCancel)="handleCancel()">

  <div *nzModalContent>
    <div class="form-group">
      <label for="justification"><b>Biometric Officer Name</b></label>
      <input class="form-control" id="bioOfficerName" name="bioOfficerName" [(ngModel)]="bioOfficerName" required>
    </div>
    <div class="form-group">
      <label><b>Biometric Capture</b></label>
      <select class="form-control" required [(ngModel)]="biometricStatus" name="biometricStatus">
        <option [ngValue]="false">Pending</option>
        <option [ngValue]="true">Captured </option>
      </select>
    </div>

    <div class="form-group">

      <label for="exampleInputCity1"><b>Capture Date</b></label>
      <input type="date" class="form-control" id="datecaptured" placeholder="" name="datecaptured"
        [(ngModel)]="datecaptured" required>
    </div>

    <div class="form-group">
      <label for="exampleInputCity1"><b>Biometric Start Date </b></label>
      <input type="date" class="form-control" id="biometricstartdate" placeholder="" name="biometricstartdate"
        [(ngModel)]="biometricstartdate" required>
    </div>
    <div class="form-group">
      <label for="exampleInputCity1"><b>Biometric End Date</b></label>
      <input type="date" class="form-control" id="biometricenddate" placeholder="" name="biometricenddate"
        [(ngModel)]="biometricenddate" required>
    </div>
  </div>

  <div *nzModalFooter>
    <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
    <button class="btn btn-primary" (click)="updateBiometrics()" [disabled]="isChangeOkLoading">Submit</button>
  </div>

</nz-modal>



<!-- Update Safety  Modal  -->
<nz-modal [(nzVisible)]="isSafetyVisible" nzTitle={{safetyTitle}} (nzOnCancel)="handleCancel2()">

  <div *nzModalContent>
    <div class="form-group">
      <label for="justification"><b>Safety Officer Name</b></label>
      <input class="form-control" id="safetyOfficer" name="safetyOfficer" [(ngModel)]="safetyOfficer" required>
    </div>
    <div class="form-group">
      <label><b>Safety Status</b></label>
      <select class="form-control" required [(ngModel)]="safetyStatus" name="safetyStatus">
        <option [ngValue]="false">Pending</option>
        <option [ngValue]="true">Captured </option>
      </select>
    </div>

    <div class="form-group">

      <label for="exampleInputCity1"><b>Safety Induction Date</b></label>
      <input type="date" class="form-control" id="safetyInductionDate" placeholder="" name="safetyInductionDate"
        [ngModel]="safetyInductionDate | date:'yyyy-MM-dd'" (ngModelChange)="onChangeInductionDate($event)" required>

    </div>



  </div>

  <div *nzModalFooter>
    <button class="btn btn-light" (click)="handleCancel2()">Cancel</button>
    <button class="btn btn-primary" (click)="updateSafety()" [disabled]="isChangeOkLoading">Submit</button>
  </div>

</nz-modal>


<!-- Terminate Employee  -->
<nz-modal [(nzVisible)]="isTerminationVisible" nzTitle={{terminateTitle}} (nzOnCancel)="handleCancel2()">

  <div *nzModalContent>
    <div class="form-group">
      <label for="justification"><b>Comment</b></label>
      <textarea class="form-control" id="terminationComment" name="terminationComment" [(ngModel)]="terminationComment"
        required>

      </textarea>
    </div>


    <div class="form-group">

      <label for="exampleInputCity1"><b>End Date</b></label>
      <input type="date" class="form-control" id="terminationDate" placeholder="" name="terminationDate"
        [ngModel]="terminationDate | date:'yyyy-MM-dd'" (ngModelChange)="onChangeTerminationDate($event)" required>

    </div>


  </div>

  <div *nzModalFooter>
    <button class="btn btn-light" (click)="handleCancel3()">Cancel</button>
    <button class="btn btn-primary" (click)="terminateEmployeeUpdate()" [disabled]="isChangeOkLoading">Submit</button>
  </div>

</nz-modal>
<nz-modal [(nzVisible)]="isOffboardVisible" nzTitle={{terminateTitle}} (nzOnCancel)="handleCancel2()">

  <div *nzModalContent>
    <div class="form-group">
      <label for="justification"><b>Comment</b></label>
      <textarea class="form-control" id="terminationComment" name="terminationComment" [(ngModel)]="terminationComment"
        required>

      </textarea>
    </div>


  </div>

  <div *nzModalFooter>
    <button class="btn btn-light" (click)="handleCancel4()">Cancel</button>
    <button class="btn btn-primary" (click)="offboardEmployeeUpdate()" [disabled]="isChangeOkLoading">Submit</button>
  </div>

</nz-modal>

<!-- Change Location  Modal  -->
<nz-modal [(nzVisible)]="isLocationModalVisible" nzTitle={{locationUpdateTitle}}
  (nzOnCancel)="handleLocationUpdateCancel()">

  <div *nzModalContent>
    <div class="form-group">
      <label for="location">Location</label>
      <select class="form-control" required [(ngModel)]="selectedLocationId" name="selectedLocationId"
        id="selectedLocationId">
        <option value="">--Select Location--</option>
        <option [value]="location.id" *ngFor="let location of Locations">{{location.name}} </option>
      </select>
    </div>
  </div>

  <div *nzModalFooter>
    <button class="btn btn-light" (click)="handleLocationUpdateCancel()">Cancel</button>
    <button class="btn btn-primary" (click)="changeLocation()" [disabled]="isChangeOkLoading">Submit</button>
  </div>

</nz-modal>

<!-- Change Contractor  Modal  -->
<nz-modal [(nzVisible)]="isContractorModalVisible" nzTitle={{contractorUpdateTitle}}
  (nzOnCancel)="handleContractorUpdateCancel()">

  <div *nzModalContent>
    <div class="form-group">
      <label for="contractor">Vendors</label>
      <select class="form-control" required [(ngModel)]="selectedContractorId" name="selectedContractorId"
        id="selectedContractorId">
        <option value="">--Select vendor--</option>
        <option [value]="vendor.id" *ngFor="let vendor of vendors">{{vendor.name}} </option>
      </select>
    </div>
  </div>

  <div *nzModalFooter>
    <button class="btn btn-light" (click)="handleContractorUpdateCancel()">Cancel</button>
    <button class="btn btn-primary" (click)="changeContractor()" [disabled]="isChangeOkLoading">Submit</button>
  </div>

</nz-modal>